'use client';

import { FC } from 'react';
import { NotificationPillProps } from './NotificationPill.types';
import { Pill, Text, Tooltip } from '@/_components';
import { NOTIFICATIONS_DATA } from '@/_constants/notifications';

export const NotificationPill: FC<NotificationPillProps> = ({
  notificationId,
}) => {
  const notification = NOTIFICATIONS_DATA[notificationId];

  if (!notification) {
    return (
      <Pill label="Notification not found" intent="info" iconLeft="x-circle" />
    );
  }

  return (
    <Tooltip placement="top">
      <Tooltip.Trigger>
        <Pill
          label={notification.name}
          intent="info"
          iconLeft="bell-ringing"
          internalIconWidth="fill"
        />
      </Tooltip.Trigger>
      <Tooltip.Content>
        <Text type="small" color="currentcolor">
          {notification.description}
        </Text>
      </Tooltip.Content>
    </Tooltip>
  );
};
